var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 76,
    viewBox: "0 0 64 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 63L60 74Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 63L60 74",
    stroke: "currentColor",
    className: "logo-surrounding",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13.4526C57.5229 8.41638 51.5092 4.80045 44.7755 3.09591C38.0418 1.39138 30.9144 1.68083 24.3613 3.92497C17.8083 6.16911 12.1471 10.2592 8.14652 15.6397C4.14598 21.0203 2 27.4305 2 34C2 40.5695 4.14598 46.9797 8.14652 52.3603C12.1471 57.7408 17.8083 61.8309 24.3613 64.075C30.9144 66.3192 38.0418 66.6086 44.7755 64.9041C51.5092 63.1995 57.5229 59.5836 62 54.5474",
    stroke: "currentColor",
    className: "logo-surrounding",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51.0049V54H16V51.0049H57ZM53.9492 46.2139V49.208H19.0508V46.2139H53.9492ZM23.4375 23.8525V44.417H20.5771V23.8525H23.4375ZM33.0996 23.8525V44.417H30.2393V23.8525H33.0996ZM42.7607 23.8525V44.417H39.9004V23.8525H42.7607ZM52.4229 23.8525V44.417H49.5625V23.8525H52.4229ZM53.9492 20.6582V22.0557H19.0508V20.6582H53.9492ZM55.9512 18.8613H17.0488L36.5 8L55.9512 18.8613Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51.0049V54H16V51.0049H57ZM53.9492 46.2139V49.208H19.0508V46.2139H53.9492ZM23.4375 23.8525V44.417H20.5771V23.8525H23.4375ZM33.0996 23.8525V44.417H30.2393V23.8525H33.0996ZM42.7607 23.8525V44.417H39.9004V23.8525H42.7607ZM52.4229 23.8525V44.417H49.5625V23.8525H52.4229ZM53.9492 20.6582V22.0557H19.0508V20.6582H53.9492ZM55.9512 18.8613H17.0488L36.5 8L55.9512 18.8613Z",
    stroke: "currentColor",
    className: "logo-column"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c291432c6d37223f1bdd623d593a3ab3.svg";
export { ForwardRef as ReactComponent };